export enum ButtonState {
  Active,
  Disabled,
  Loading,
}
